export default __webpack_public_path__ + "static/media/mmuzammal.fdc8fa48.pdf";